import { Button } from '@ui/lib/park/ui/button';
import { useTranslation } from 'next-i18next';
import { Box, HStack } from 'styled-system/jsx';

import { useTradeFlowPriceChartStore } from '../../store/useTradeFlowPriceChartStore';
import { LongShortButtonGroup } from '../LongShortButtonGroup';
import { OrderTypeButtonGroup } from '../OrderTypeButtonGroup';
import { useIsLong } from './store/useIsLong';
import { useOrderType } from './store/useOrderType';

export const Toggles = () => {
  const [orderType, setOrderType] = useOrderType((s) =>
    s.useDebouncedPersistState(200),
  );
  const [isLong, setIsLong] = useIsLong((s) => s.useDebouncedPersistState(200));

  return (
    <Box p="0px 12px 8px">
      <OrderTypeButtonGroup orderType={orderType} setOrderType={setOrderType} />
      <HStack gap="24px" mt="8px">
        <LongShortButtonGroup isLong={isLong} setIsLong={setIsLong} />
      </HStack>
    </Box>
  );
};
